import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'projects/foreign-admits/src/environments/environment';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';

@Injectable({
  providedIn: 'root'
})
export class OpenAIService {
  private baseUrl: string = environment.apiBaseUrl;
  private backendUrl = `${this.baseUrl}/university-courses/generate-job-opportunities`; 
  

  constructor(private http: HttpClient, private apiHelperService: ApiHelperService) {}

  getJobDetails(payload: { country: string; course: string; university: string }): Promise<any> {
    return this.apiHelperService.postDataWithShortlistingUrl('university-courses/generate-job-opportunities', payload);
  }

  getCostOfLivingDetails(payload: { city: string; country: string }): Promise<any> {
    return this.apiHelperService.postDataWithShortlistingUrl('university-courses/generate-cost-of-living', payload);
  }
}
